const useStyles = () => {
    return {
        container: (coment:boolean) => ({
            display: 'flex', 
            flexDirection: 'column',
            gap: !coment ?  2:0,
            '& .color-primary': {
                color: 'primary.100'
            },
            '& .color-delete': {
                color: 'c_red.main'
            },
            padding: !coment ? 3:'24px 24px 0px 24px',
            '&.MuiPaper-root':{
                boxShadow: 'none'
            }
        }),
        commentContainer: {
            maxHeight: '500px',
            overflow: 'auto',
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
            padding: 1,
        },
        comment: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
        },
        addorment: {
            alignItems: 'start',
            position: 'relative',
            bottom: '-10px',
            right: '-10px'
        },
        closeAddorment: {
            alignItems: 'start',
            position: 'absolute',
            top: '5px',
            right: '5px'
        },
        header: {
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '0px 8px'
        },
        noComment: {
            padding:'0px 8px'
        }
    }
}

export { useStyles }
